import React from 'react';
import { Box, Flex } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../../constants/styles';
import { TableLoader } from './table-loader';

interface Props {
  testId?: string;
  tableColumnCount?: number;
}

/**
 * CollapsibleSummaryTableLoader component is used to render the loader for the collapsible summary grid section and table loader inside it.
 * This is used in the catalog details page.
 * @param {string} testId - testId for the component.
 * @param {number} tableColumnCount - number of columns to be shown in the table.
 */

export const CollapsibleSummaryTableLoader = ({
  testId = 'collapsible-summary-table-loader',
  tableColumnCount,
}: Props) => {
  return (
    <div data-testid={testId} className="pt-20">
      <Box padding="space.250" xcss={boxStyles} paddingBlockStart="space.200">
        <SkeletonLoaderWrapper>
          <SkeletonLoader width="24px" />
          <SkeletonLoader width="20%" />
        </SkeletonLoaderWrapper>
        <SkeletonLoaderWrapper>
          {/* Bottom border */}
          <SkeletonLoader width="100%" height="1px" />
        </SkeletonLoaderWrapper>
        <TableLoader hideSearchBar hideFilters hideActions columnsCount={tableColumnCount} />
      </Box>
    </div>
  );
};
